<template>
  <v-container fill-height>
    <v-layout justify-center>
      <v-flex xs12 sm12 lg12 xl8 offset-xl2>
        <h1 class="display-1 mt-4 mb-1 text-xs-center">
          MLS Listing {{ listing.listingId }}
        </h1>
        <p class="subheading text-xs-center font-italic grey--text">
          {{ listing.disclaimer }}
        </p>
        <listing-header :listing="listing"></listing-header>
        <v-carousel
          v-if="listing.photos.length"
          hide-delimiters
          :height="carouselHeight"
          class="images"
        >
          <v-carousel-item
            v-for="(image, i) in listing.photos"
            :key="i"
            :src="image"
          ></v-carousel-item>
        </v-carousel>
        <p class="subheading mt-3 mb-4">{{ listing.remarks }}</p>
        <property-map
          :coords="[listing.geo.lng, listing.geo.lat]"
        ></property-map>
        <v-card class="mt-5" raised>
          <v-layout row wrap>
            <v-card-title primary-title>
              <h2 class="display-1 my-4">
                Property details for {{ listing.address.full }}
              </h2>
            </v-card-title>
            <v-flex xs12>
              <v-card>
                <v-layout column>
                  <v-toolbar color="grey lighten-3">
                    <v-toolbar-title>
                      Virtual Tour, Parking / Garage, Homeowners Association,
                      School / Neighborhood
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 sm6>
                        <div class="mt-2">
                          <div class="subheading">Virtual Tour</div>
                          <ul>
                            <li>
                              <a :href="listing.virtualTourUrl">
                                Virtual Tour (external link)
                              </a>
                            </li>
                          </ul>
                        </div>
                        <div class="mt-2">
                          <div class="subheading">
                            Parking/Garage Information
                          </div>
                          <ul>
                            <li>
                              Parking Type:
                              {{ listing.property.parking.description }}
                            </li>
                            <li>
                              Garage Spaces: {{ listing.property.garageSpaces }}
                            </li>
                          </ul>
                        </div>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <div class="mt-2">
                          <div class="subheading">
                            Homeowners Association Information
                          </div>
                          <ul>
                            <li>
                              Association Features:
                              {{ listing.association.amenities }}
                            </li>
                            <li>
                              Association Fees: {{ listing.association.fee }}
                            </li>
                          </ul>
                        </div>
                        <div class="mt-2">
                          <div class="subheading">
                            School Information
                          </div>
                          <ul>
                            <li>
                              Elementary School:
                              {{ listing.school.elementarySchool }}
                            </li>
                            <li>
                              Middle School: {{ listing.school.middleSchool }}
                            </li>
                            <li>
                              High School: {{ listing.school.highSchool }}
                            </li>
                          </ul>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-layout column>
                  <v-toolbar color="grey lighten-3">
                    <v-toolbar-title>
                      Interior Features
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 sm6>
                        <div class="mt-2">
                          <div class="subheading">
                            Bedroom and Bathroom Information
                          </div>
                          <ul>
                            <li>Bedroom Downstairs:</li>
                            <li>Bedrooms: {{ listing.property.bedrooms }}</li>
                            <li>
                              Bathrooms(Full): {{ listing.property.bathsFull }}
                            </li>
                            <li>
                              Bathrooms(Half): {{ listing.property.bathsHalf }}
                            </li>
                            <li>
                              Bathrooms(3/4):
                              {{ listing.property.bathsThreeQuarter }}
                            </li>
                            <li>Bathroom Downstairs:</li>
                            <li>3/4 Bath Downstairs:</li>
                          </ul>
                        </div>
                        <div class="mt-2">
                          <div class="subheading">
                            Kitchen and Dining Room Information
                          </div>
                          <ul>
                            <li>Range:</li>
                            <li>Oven Description:</li>
                            <li>Refrigerator:</li>
                            <li>Other Appliance Description:</li>
                            <li>Dishwasher:</li>
                            <li>Disposal:</li>
                          </ul>
                        </div>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <div class="mt-2">
                          <div class="subheading">
                            Interior Features
                          </div>
                          <ul>
                            <li>Blinds:</li>
                            <li>Dryer Included:</li>
                            <li>Dryer Utilities:</li>
                            <li>
                              Fireplaces: {{ listing.property.fireplaces }}
                            </li>
                            <li>Fireplace Description:</li>
                            <li>Fireplace Location:</li>
                            <li>
                              Flooring Description:
                              {{ listing.property.flooring }}
                            </li>
                            <li>
                              Rooms: {{ listing.property.additionalRooms }}
                            </li>
                            <li>Washer Included:</li>
                            <li>Washer Dryer Location:</li>
                          </ul>
                        </div>
                        <div class="mt-2">
                          <div class="subheading">
                            Other Room Information
                          </div>
                          <ul>
                            <li>none</li>
                          </ul>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-layout column>
                  <v-toolbar color="grey lighten-3">
                    <v-toolbar-title>
                      Exterior Features
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 sm6>
                        <div class="mt-2">
                          <div class="subheading">
                            Exterior Features
                          </div>
                          <ul>
                            <li>
                              Roof Description: {{ listing.property.roof }}
                            </li>
                            <li>Fence:</li>
                            <li>Fence Type:</li>
                            <li>Landscape Description:</li>
                            <li>Gated: {{ listing.association.gated }}</li>
                            <li>
                              Exterior Description:
                              {{ listing.property.exteriorFeatures }}
                            </li>
                            <li>Spa:</li>
                            <li>Pool: {{ listing.property.pool }}</li>
                            <li>Pool Description:</li>
                          </ul>
                        </div>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <div class="mt-2">
                          <div class="subheading">
                            Building Information
                          </div>
                          <ul>
                            <li>
                              Building Description:
                              {{ listing.property.stories }}
                            </li>
                          </ul>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-layout column>
                  <v-toolbar color="grey lighten-3">
                    <v-toolbar-title>
                      Utilities, Taxes / Assessments, Location Details
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 sm6>
                        <div class="mt-2">
                          <div class="subheading">
                            Utility Information
                          </div>
                          <ul>
                            <li>
                              Green Building Certification:
                            </li>
                            <li>Energy Description:</li>
                            <li>Power:</li>
                            <li>Heating Fuel:</li>
                            <li>
                              Heating Description:
                              {{ listing.property.heating }}
                            </li>
                            <li>Cooling: {{ listing.property.cooling }}</li>
                            <li>Sewer:</li>
                            <li>Solar Electric:</li>
                            <li>Water: {{ listing.property.water }}</li>
                            <li>Utility Information:</li>
                          </ul>
                        </div>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <div class="mt-2">
                          <div class="subheading">
                            Tax/Assessment Information
                          </div>
                          <ul>
                            <li>
                              Tax District:
                              {{ listing.tax.id }}
                            </li>
                            <li>
                              Annual Property Taxes:
                              {{ listing.tax.taxAnnualAmount }}
                            </li>
                          </ul>
                        </div>
                        <div class="subheading">
                          Location Details
                        </div>
                        <ul>
                          <li>
                            Subdivision Name: {{ listing.property.subdivision }}
                          </li>
                          <li>Directions: {{ listing.geo.directions }}</li>
                          <li>Community Name:</li>
                          <li>Area: {{ listing.mls.area }}</li>
                        </ul>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-layout column>
                  <v-toolbar color="grey lighten-3">
                    <v-toolbar-title>
                      Property / Lot Details
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 sm6>
                        <div class="mt-2">
                          <div class="subheading">
                            Property Features
                          </div>
                          <ul>
                            <li>Equestrian Description: n/a</li>
                            <li>
                              Approx Total Living Area:
                              {{ listing.property.area }}
                            </li>
                          </ul>
                        </div>
                        <div class="mt-2">
                          <div class="subheading">
                            Lot Information
                          </div>
                          <ul>
                            <li>
                              Lot Description:
                              {{ listing.property.lotDescription }}
                            </li>
                            <li>Parcel Number: {{ listing.tax.id }}</li>
                            <li>Acres: {{ listing.property.acres }}</li>
                            <li>
                              Lot Sqft: {{ listing.property.lotSizeArea }}
                            </li>
                            <li>Zoning: {{ listing.property.subTypeText }}</li>
                          </ul>
                        </div>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <div class="mt-2">
                          <div class="subheading">
                            Property Information
                          </div>
                          <ul>
                            <li>Lofts: n/a</li>
                            <li>SID/LID: n/a</li>
                            <li>SIDLID Balance: n/a</li>
                            <li>SIDLID Annual Amount: n/a</li>
                            <li>Land Use: {{ listing.property.type }}</li>
                            <li>Master Plan Fee MQYN: n/a</li>
                            <li>Master Plan Fee Amount: n/a</li>
                            <li>
                              Construction Description:
                              {{ listing.property.construction }}
                            </li>
                            <li>House Faces: {{ listing.property.view }}</li>
                            <li>Builder: n/a</li>
                            <li>
                              Built Description:
                              {{ listing.property.yearBuilt }}
                            </li>
                          </ul>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-layout row pa-2>
              <app-social-share></app-social-share>
              <v-spacer></v-spacer>
<!--              <favorite :mls-id="mlsId" favorited="favorited"></favorite>-->
            </v-layout>
          </v-card-actions>
        </v-card>
        <agent-disclaimer></agent-disclaimer>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { getListing } from '../api/simplyrets';
import ListingHeader from '../components/ListingHeader';
import PropertyMap from '../components/PropertyMap';
import AgentDisclaimer from '../components/AgentDisclaimer';
// import Favorite from '../components/Favorite';

export default {
  name: 'Listing',
  metaInfo: {
    title: 'MLS Listing',
  },
  components: {
    ListingHeader,
    PropertyMap,
    AgentDisclaimer,
    // Favorite,
  },
  data() {
    return {
      listing: [],
      // favorited: false,
    };
  },
  computed: {
    // eslint-disable-next-line
    carouselHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '240';
        case 'sm':
          return '480';
        case 'md':
        case 'lg':
        case 'xl':
          return '576';
      }
    },
    mlsId() {
      return this.$route.params.mlsId.toString();
    },
  },
  mounted() {
    this.getListing();
  },
  methods: {
    getListing() {
      getListing(this.mlsId).then((res) => {
        this.listing = res;
      });
    },
  },
};
</script>

<style scoped>
.images .v-window__container {
  height: 100% !important;
}
</style>
